module.exports = __webpack_public_path__ + "static/guy-kawasaki-f26c67d645cc9447a7419f68d50f4610.jpg";